import { render, staticRenderFns } from "./bg-quotation-marks.vue?vue&type=template&id=0bd19bb6&scoped=true&"
import script from "./bg-quotation-marks.vue?vue&type=script&lang=js&"
export * from "./bg-quotation-marks.vue?vue&type=script&lang=js&"
import style0 from "./bg-quotation-marks.vue?vue&type=style&index=0&id=0bd19bb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd19bb6",
  null
  
)

export default component.exports